import type { APIWithPagination, SWRConfigInterface } from '@gik/core/api/BaseAPIConfig';
import { dotnetApi } from '@gik/core/api/ky/dotnetApi';
import { useApi } from '@gik/core/api/swr/useApi';
import type { Product } from '@gik/core/models/gik/Product';

const path = 'products';

export type SimilarProductsParams = {
  relationIds?: number[]; // custom search
  taxonomySlugs?: string[]; // custom search
  similarTo?: string | number; // product slug or ID
  suggestedFor?: string; // inkind route ID
} & APIWithPagination;

export function getParams(params?: SimilarProductsParams) {
  return {
    perPage: 10,
    ...params,
    relationIds: params?.relationIds?.join(','),
    taxonomies: params?.taxonomySlugs?.join(','),
    // _fields: 'id,name,slug,description,gridImage',
  };
}

export function getSimilarProducts(params?: SimilarProductsParams) {
  return dotnetApi
    .get(path, {
      searchParams: getParams(params),
    })
    .json<Product[]>();
}

export function useSimilarProducts(params?: SimilarProductsParams, config?: SWRConfigInterface) {
  const isValid = (params.relationIds && params.taxonomySlugs) || !!params.suggestedFor || !!params.similarTo;
  return useApi<Product[]>(isValid ? path : null, getParams(params), config);
}
